import React from 'react';
import ForbiddenContent from '../ForbiddenContent';

const Forbidden = () => (
  <div className="text-center">
    <ForbiddenContent />
  </div>
);

export default Forbidden;
